const pointsAwardDeductLimit = 10000;

const pointsForm = {
  pointsAwardDeductLimit,
};

export default pointsForm;
